(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[461],{

/***/ "FFcw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pinterest", function() { return Pinterest; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Pinterest = function Pinterest(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 349.46 487.47"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M209.55 352.33c-28 0-54.31-16.32-63.32-34.9 0 0-15.09 64.46-18.25 76.93-11.25 44-44.29 88-46.84 91.65a3.36 3.36 0 0 1-6.12-1.52c-.74-5.65-9.17-61.23.76-106.51 5-22.75 33.35-152.57 33.35-152.57s-8.27-17.86-8.27-44.27c0-41.51 22.28-72.46 50-72.46 23.58 0 34.92 19.08 34.92 42 0 25.64-15.06 64-22.89 99.34-6.48 29.77 13.79 53.89 40.95 53.89 49.07 0 82.26-68.07 82.26-148.79 0-61.39-38.3-107.34-107.93-107.34-78.63 0-127.67 63.37-127.67 134.11 0 24.43 6.7 41.62 17.12 54.92 4.8 6.14 5.47 8.59 3.74 15.56-1.28 5.2-4.1 17.59-5.29 22.46-1.72 7.13-7 9.7-13 7-36.22-15.89-53.1-58.79-53.1-106.94C-.03 95.36 62.08-.05 185.29-.05c99 0 164.14 77.37 164.14 160.46.01 109.9-56.54 191.92-139.88 191.92z",
    fill: "#010101"
  }));
};

/***/ })

}]);